import SectionHeading from "@/components/base/SectionHeading";
import LiveCard from "@/components/base/LiveCard";
import { liveSessions } from "@/mocks/lives";

export default function LiveNowStrip() {
  const nowLive = liveSessions.filter((item) => item.status === "live");

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20" aria-labelledby="live-now-title">
      <SectionHeading
        eyebrow="Live Now"
        title="此刻正在直播的现场"
        desc="每一张卡都是一路正在回传的实时画面信号。点击进入，可以看到完整的现场镜头、信号状态与连麦声音。"
        linkTo="/live"
        linkLabel="查看全部 12 路信号"
      />
      <h2 id="live-now-title" className="sr-only">
        正在直播的现场信号列表
      </h2>

      <div className="mt-8 flex gap-4 overflow-x-auto pb-3 no-scrollbar md:mt-10 md:gap-5">
        {nowLive.map((item, index) => (
          <LiveCard
            key={item.id}
            item={item}
            index={index + 1}
            className="w-[280px] shrink-0 sm:w-[320px] lg:w-[calc((100%-3.75rem)/4)]"
          />
        ))}
        <article className="flex w-[230px] shrink-0 flex-col justify-between rounded-lg border border-dashed border-background-300/70 bg-background-100/50 p-5">
          <div>
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100/60 text-primary-500">
              <i className="ri-add-circle-line text-xl" aria-hidden="true" />
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
              更多信号准备接入
            </h3>
            <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">
              编辑组正在核实新的现场线索，确认机位安全后会立即开通回传。
            </p>
          </div>
          <a
            href={`mailto:tip@baoliaozhibo.com`}
            className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-primary-500 transition-colors hover:text-primary-600"
          >
            <i className="ri-send-plane-line" aria-hidden="true" />
            提供现场线索
          </a>
        </article>
      </div>
    </section>
  );
}